(function (window, $) {
  var $registrationContainer = $('#soulcup-register-main');
  var $pickupStudioSelect = $registrationContainer.find('select[name=prize_pickup_studio_id]');
  var $optInRewardMailCheckbox = $registrationContainer.find('input[name=email_opt_in]');
  var $joinTeamCheckbox = $registrationContainer.find('input[name=join_team_checkbox]');
  var $joinTeamInput = $registrationContainer.find('input[id=join-team-input]');

  var teamCodeInputHidden = !$registrationContainer.find('.join-team-input-wrapper').length;
  var source = teamCodeInputHidden ? 'invite' : 'Enroll';

  /**
   * Do nothing
   *
   * @returns {undefined}
   */
  function noop() {}

  // soulcup/analytics.js might have not been loaded.
  // Initialization is deferred if it has not been loaded
  var analytics = {
    track: noop,
    update: noop
  };

  if ($('.soulcup-register').length) {
    loadAnalyticsManager();
  }

  var registerRider = function (form) {
    analytics.track('Click Finish Sign up', source);
    if (!$pickupStudioSelect.val()) {
      $pickupStudioSelect.addClass('field-error');
      // Flash yellow message on navbar
      confirmation(null, ('Please select your home studio.'));
      return;
    }

    if ($joinTeamCheckbox.first().prop('checked') && !$joinTeamInput.val()) {
      $joinTeamInput.addClass('field-error');
      // Flash yellow message on navbar to enter code on input
      confirmation(null, ('Please enter team code.'));
      return;
    }

    var formData = form ? new FormData(form[0]) :
      null;

    $.ajax({
      url: '/turn-it-up/register/',
      data: formData,
      type: 'post',
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function (data) {
        var response = data.payload;

        // Check response for any errors
        if (response.error_message) {
          switch (response.error_field) {
          // Invalid prize pickup studio
          case 'prize_pickup_studio_id':
            $pickupStudioSelect.addClass('field-error');
            confirmation(null, response.error_message);
            break;
          // Rider not logged in.
          case 'rider':
            window.location.href = '/turn-ip-up/';
            break;
          // Rider already registered
          case 'registered':
            window.location.href = '/turn-it-up/me/';
            confirmation(null, response.error_message);
            break;
          // Invalid code
          case 'code':
            showTeamCodeError(response.error_message);
            break;
          // Team disbanded
          case 'disbanded':
            showTeamCodeError(response.error_message);
            break;
          // Team is full
          case 'full':
            showTeamCodeError(response.error_message);
            break;
          default:
            confirmation(null, response.error_message);
          }

          analytics.track('Get Register Response', source, {
            Response: 'Submit error - form error: ' + response.error_message,
            Location: 'Form'
          });
        } else {
          // Register email on Braze via mParticle if rider checked opt in
          if ($optInRewardMailCheckbox.first().prop('checked')) {
            SC.analytics.mp.userEvent('attribute', 1, 'soulcup-reward-optin');
          }

          analytics.update({
            'Enrollment Status': 'Enrolled'
          });
          analytics.track('Get Register Response', source, {
            Response: 'Success',
            Location: 'Form'
          });

          window.location.href = '/turn-it-up/me/';
        }
      },
      error: function (response, status) {
        confirmation(null, ('Could not fulfill this request.'));

        analytics.track('Get Register Response', source, {
          Response: 'Submit error - status: ' + status,
          Location: 'Form'
        });
      }
    });
  };


  $pickupStudioSelect.change(function () {
    $pickupStudioSelect.removeClass('field-error');
  });

  $registrationContainer.find('form.soulcup-registration-form').submit(function (e) {
    e.preventDefault();
    var form = $(this);
    registerRider(form);
  });

  $registrationContainer.find('.charity-selection-box').click(function () {
    var $input = $(this).find('input[name=charity]');
    $input.prop('checked', true);
    $input.change();
  });

  $registrationContainer.find('.goal-selection-box').click(function () {
    var $input = $(this).find('input[name=goal]');
    $input.prop('checked', true);
    $input.change();
  });

  $joinTeamCheckbox.change(function () {
    document.getElementById('join-team-input').disabled = !this.checked;
  });

  $joinTeamInput.on('input', function () {
    $('.join-team-input-wrapper').removeClass('join-team-input-wrapper-error');
    $('.errorMessageFlash').html('');
  });

  var showTeamCodeError = function (message) {
    if (teamCodeInputHidden) {
      confirmation(null, message + ' You can still join without a team.');

      // allow completing registration without a team
      $joinTeamCheckbox.prop('checked', false);
    } else {
      $('.join-team-input-wrapper').addClass('join-team-input-wrapper-error');
      $('#team-error-message-flash').html(message);
    }
  };

  /**
   * Load the analytics manager whenever it is ready
   *
   * @returns {undefined}
   */
  function loadAnalyticsManager() {
    /**
     * Do the actual loading
     *
     * @returns {undefined}
     */
    function doLoad() {
      if (typeof window.SC !== 'undefined' && typeof window.SC.soulcupAnalytics !== 'undefined' && typeof window.SC.soulcupAnalytics.createAnalyticsManager) {
        analytics = window.SC.soulcupAnalytics.createAnalyticsManager('Enroll', {
          'Enrollment Status': 'Unenrolled',
          'Team Status': 'Solo',
          'Team ID': ''
        });
        analytics.track('View Screen', source);
        return;
      }

      // Try again after 200 ms if analytics was not yet available
      setTimeout(loadAnalyticsManager, 200);
    }

    doLoad();
  }
})(window, jQuery);
